<template>
	<div>
		<Clist :ShowFilas="false" :pShowBtnAdd="false" :regresar="false" :Nombre="NameList" :Pag="Pag" :Total="TotalPagina" @FiltrarC="Lista" :Filtro="Filtro" :pConfigLoad="ConfigLoad" :ShowBusqueda="true">
			<template slot="Filtros">
				<label for="">Año</label>
				<select @change="Lista" v-model="Filtro.Anio" class="ml-2 form-control" id="">
					<option value="">Todos</option>
					<option v-for="(item,index) in ListaAnios" :key="index" :value="item">{{item}}</option>
				</select>
			</template>
			<template slot="header">
				<tr>
					<th style="width:15%">Cliente</th>
					<th style="width:15%">Propiedad</th>
					<th>Total</th>
					<th class="pr-5 text-center">Facturas</th>
					<th>30 Días</th>
					<th class="pr-5 text-center">Facturas</th>
					<th>+30 Días</th>
					<th class="pr-5 text-center">Facturas</th>
					<th>+60 Días</th>
					<th class="pr-5 text-center">Facturas</th>
					<th>+ 90 Días</th>
					<th class="pr-5 text-center">Facturas</th>
				</tr>
			</template>
			<template slot="body">
				<tr v-for="(item, index) in Facturacion" :key="index">
					<td>{{$limitCharacters(item.Cliente,45)}}</td>
					<td>{{$limitCharacters(item.Propiedad,45)}}</td>
					<td class="pr-0" style="width:1%">$ {{formateoMillon(parseInt(item.Total))}}</td>
					<td class="text-center pr-5" style="width:1%">{{item.ContadorTotal}}</td>
					<td class="pr-0" style="width:3%">$ {{formateoMillon(parseInt(item.DiasTreinta))}}</td>
					<td class="text-center pr-5" style="width:1%">{{item.ContadorTreinta}}</td>
					<td class="pr-0" style="width:3%">$ {{formateoMillon(parseInt(item.MasDiasTreinta))}}</td>
					<td class="text-center pr-5" style="width:1%">{{item.ContadorMasTreinta}}</td>
					<td class="pr-0" style="width:3%">$ {{formateoMillon(parseInt(item.DiasSesenta))}}</td>
					<td class="text-center pr-5" style="width:1%">{{item.ContadorSesenta}}</td>
					<!-- <td class="pr-0" style="width:3%">$ {{formateoMillon(parseInt(item.DiasNoventa))}}</td>
					<td>{{item.ContadorNoventa}}</td> -->
					<td class="pr-0" style="width:3%">$ {{formateoMillon(parseInt(item.MasDiasNoventa))}}</td>
					<td class="text-center pr-5" style="width:1%">{{item.ContadorMasNoventa}}</td>
				</tr>
			</template>
		</Clist>
	</div>
</template>

<script>
import Clist from "@/components/Clist.vue";
import Cbtnaccion from "@/components/Cbtnaccion.vue";
export default {
	name:"Facturacion",
	components:{Clist,Cbtnaccion},
	data() {
		return {
			NameList: "Reporte Pago por Cliente",
			TotalPagina: 2,
			Pag: 0,
            Filtro:{
                Entrada: 20,
				Nombre: "",
				Placeholder: "Cliente / Propiedad..",
				TotalItem: 0,
				Pagina: 1,
                Anio:new Date().getFullYear()
            },
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			Facturacion:[],
			ListaAnios:[]
		}
	},
	methods: {
		async Lista(){
			this.ConfigLoad.ShowLoader=true;
			await this.$http.get('facturacioncobranza',{
				params:{
					Nombre:this.Filtro.Nombre,
                    Entrada:this.Filtro.Entrada,
                    pag:this.Filtro.Pagina,
					Anio:this.Filtro.Anio
				}
			}).then((res) => {
				this.Facturacion=res.data.data.data;
                this.Filtro.Entrada=res.data.data.pagination.PageSize;
                this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                // this.Sucursal=res.data.data.sucursal;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			})
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
		async anios() {
			await this.$http.get("funciones/getanios").then(res => {
				//console.log('Calling Years');
				this.ListaAnios = res.data.ListaAnios;
				this.Lista();
				// this.anioActual = res.data.AnioActual;
				// this.listFacturacion();
			});
		},
	},
	created() {
		this.bus.$off('Regresar');
		this.bus.$on('Regresar',()=>{
			this.$router.push({name:'menucobranza'});
		});
	},
	mounted() {
		this.anios();
	},
}
</script>

<style>

</style>
